<div class="listing flex" (mouseenter)="onlistinghovered.emit(listing)" [ngClass]="{'focus-listing': selectedListing}"
  *ngIf="listing">
  <div [id]="'controls'+ (listing.id || listing._id) + (isMobile ? 'mobile' : '')" class="carousel"
    [ngClass]="{'focus-carousel': selectedListing}" data-bs-interval="false">
    <!-- <img *ngIf="(listing.user)?.trusted_partner" class="gold-badge" src="assets/icons/gold-badge.png"
      tooltip="{{trustedString}}" /> -->
      <h4 *ngIf="listing?.is_external === true" class="pe-2 rating"> <span> {{starRating}} Star Hotel </span> 
        <!-- <rating [(ngModel)]="rate" [max]="max" [readonly]="isReadonly" style="color: #FACA38"></rating> -->
      </h4>
      <span [ngClass]="listing.is_external === true ? 'external' : 'internal'" class=" propertyType  external"><p>{{listing.property_type | titlecase}}</p></span>
    <ol class="carousel-indicators" *ngIf="((listing.room || listing.property).images).length > 1">
      <li [attr.data-bs-target]="'#controls'+ (listing.id || listing._id) + (isMobile ? 'mobile' : '')"
        *ngFor="let image of ((listing.room || listing.property).images); let i = index" [attr.data-bs-slide-to]="i"
        class=" {{ (i == 0) ? 'active' : ''}}"></li>
    </ol>
    <div class="carousel-inner">
      <div (click)="listing?.is_external === true ? openRoomModal((listing.id || listing._id), listing.platform) : viewProperty(listing.id || listing._id)"
        *ngFor="let image of ((listing.room || listing.property).images); let i = index"
        class="image lozad carousel-item {{ (i == 0) ? 'active' : ''}}"
        [style.background-image]="'url(' + image.url + ')'">
        <img class="image w-100" [attr.data-src]="image.url" [alt]="(listing.room || listing.property).display_name" />
      </div>
      <button class="carousel-control-prev" type="button" *ngIf="((listing.room || listing.property).images).length > 1"
        [attr.data-bs-target]="'#controls'+(listing.id || listing._id) + (isMobile ? 'mobile' : '')"
        data-bs-slide="prev">
        <fa-icon class="fa-icon-md text-black" [icon]="icons.arrowLeft"></fa-icon>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" *ngIf="((listing.room || listing.property).images).length > 1"
        [attr.data-bs-target]="'#controls'+(listing.id || listing._id) + (isMobile ? 'mobile' : '')"
        data-bs-slide="next">
        <fa-icon class="fa-icon-md text-black" [icon]="icons.arrowRight"></fa-icon>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
  <div class=" d-flex justify-content-between flex-column p-4 flex-1 ">

    <div class="d-flex justify-content-between align-items-center fs-11 ">
      <!-- <div *ngIf="(listing.user)?.trusted_partner" class="d-flex">
        <img class="me-2" src="assets/icons/badge-check 1.svg" tooltip="{{trustedString}}" />
      </div> -->

      <div class="">
        <p class="price"><span>FROM</span> 
        </p>
        
        <div *ngIf="listing?.is_external !== true">
          <p class="price">{{(listing.room || listing.property).rent?.amount | currency: listing.rent?.currency}} <span>{{listing.rent?.cycle |
            rentCycle }}</span></p>
        </div>
        <div class="price d-flex gap-2 align-items-end " *ngIf="listing?.is_external === true">
          <p class="mb-0 main" *ngIf="showBenchMark">
            {{(listing.room || listing.property).rent?.benchmark | currency: listing.rent?.currency}}</p>
          <p class="mb-0" >
            {{(listing.room || listing.property).rent?.amount | currency: listing.rent?.currency}} </p>
          <span>{{listing.rent?.cycle |
                rentCycle }}</span>
        </div>
      </div>
      <span *ngIf="listing?.is_external !== true" (click)="addToFavourite(listing.id || listing._id, favourite)">
        <img class="fav" src="{{!favourite ?  'assets/images/listings/unfavourite.svg' : 'assets/images/listings/favourite.svg'}}" alt="" alt="favourite icon">

      </span>
    </div>


    <h6 class="title-desk" *ngIf="listing?.is_external !== true" (click)="viewProperty(listing.id || listing._id)">
      {{(listing.room
      ||
      listing.property).display_name}}
    </h6>
    <h6 class="title-desk" *ngIf="listing?.is_external === true" (click)="openRoomModal((listing.id || listing._id), listing.platform)">
      {{(listing.room ||
        listing.property).display_property_name}}
    </h6>
    
    
    <h6 class="title-mob" *ngIf="listing?.is_external !== true" (click)="viewProperty(listing.id || listing._id)">
      {{
      (listing.room || listing.property).display_name!.length > 24 ?
      (listing.room
      ||
      listing.property).display_name?.slice(0,25) + "..." : (listing.room
      ||
      listing.property).display_name}}
    </h6>
    <h6 class="title-mob" *ngIf="listing?.is_external === true" (click)="openRoomModal((listing.id || listing._id), listing.platform)">
      {{
      (listing.room || listing.property).display_name!.length > 24 ?
      (listing.room
      ||
      listing.property).display_property_name?.slice(0,25) + "..." : (listing.room
      ||
      listing.property).display_property_name}}
    </h6>
    <p class="star my-2" *ngIf="rate"> <span>{{rate}} </span> (Review ratings)  </p>

    <!-- <h6 class="title-mob" [routerLink]="['/listings', listing.id || listing._id]">
      {{
      (listing.room || listing.property).display_name!.length > 24 ?
      (listing.room
      ||
      listing.property).display_name?.slice(0,25) + "..." : (listing.room
      ||
      listing.property).display_name}}
    </h6> -->

    <!-- <p *ngIf="!isMobile && (listing.room ||listing.property)?.description" class="text-mute listing-desc"
      [innerText]="(listing.room ||listing.property)?.description?.slice(0,38) + '...'">
    </p> -->

    <div class="location-mob mt-2">

      <h6>
        <fa-icon [icon]="icons.map" class="black">
        </fa-icon>

        <span class="f-size-mobile">
          {{(listing.property?.address?.city || '')}}
        </span>
      </h6>
    </div>


    <div class="props">
      <span>
        <h6 *ngIf="(listing.property).guests_allowed">
          <span>{{(listing.property).guests_allowed}} Guests</span> <span class="dot-circle"></span>
        </h6>
        <h6 *ngIf="(listing.property).total_rooms">
          <fa-icon [icon]="icons.bed" class="black"></fa-icon> 
          <span>{{ listing.is_external === true ? listing.total_beds : (listing.property).total_rooms}}</span> 
          <span class="dot-circle"></span>
        </h6>
        <h6 *ngIf="(listing.property).bathrooms">
          <fa-icon [icon]="icons.bath" class="black"></fa-icon> <span>{{(listing.property).bathrooms}}</span>
          <span class="dot-circle"></span>
        </h6>

        <div class="location">

          <h6>
            <fa-icon [icon]="icons.map" class="black">
            </fa-icon>

            <span>
              {{(listing.property?.address?.postcode || '') | postcode}}
            </span>
          </h6>
        </div>

      </span>
    </div>
  </div>

</div>
